import { useCallback, useEffect, useState } from 'react';

import { getAlertClosureReasons } from '../api/services/Alerts';

type ClosureReasonOption = { id: number; key: string; description: string };

interface IUseClosureReasons {
  closureReasonOptions?: ClosureReasonOption[];
}

export const useClosureReasons = (): IUseClosureReasons => {
  const [closureReasonOptions, setClosureReasonOptions] = useState<ClosureReasonOption[]>();

  const fetchClosureReasons = useCallback(async () => {
    const response = await getAlertClosureReasons();

    if (response.type === 'success') {
      setClosureReasonOptions(response.data);
    }
  }, []);

  useEffect(() => {
    fetchClosureReasons();
  }, [fetchClosureReasons]);

  return {
    closureReasonOptions,
  };
};
